export const getCookie = (name) => {
  if (!name || !document.cookie) {
    return '';
  }

  const encodedName = encodeURIComponent(name);
  const cookie = document.cookie
    .split('; ')
    .find((value) => value.startsWith(`${encodedName}=`));

  if (!cookie) {
    return '';
  }

  const [, cookieValue = ''] = cookie.split('=');

  return decodeURIComponent(cookieValue);
};

export const setCookie = (name, value, options = {}) => {
  if (!name) {
    return;
  }

  const {
    maxAge,
    expires,
    path = '/',
    domain,
    sameSite,
    secure,
  } = options;

  // const cookieParts = [`${encodeURIComponent(name)}=${encodeURIComponent(value ?? '')}`];
  const cookieParts = [`${encodeURIComponent(name)}=${value ?? ''}`];

  if (typeof maxAge === 'number') {
    cookieParts.push(`Max-Age=${maxAge}`);
  }

  if (expires instanceof Date) {
    cookieParts.push(`Expires=${expires.toUTCString()}`);
  }

  if (path) {
    cookieParts.push(`Path=${path}`);
  }

  if (domain) {
    cookieParts.push(`Domain=${domain}`);
  }

  if (sameSite) {
    cookieParts.push(`SameSite=${sameSite}`);
  }

  if (secure) {
    cookieParts.push('Secure');
  }

  document.cookie = cookieParts.join('; ');
};

export const removeCookie = (name, options = {}) => {
  setCookie(name, '', { ...options, maxAge: 0 });
};
